import Resource from './Resource'

class WorkType extends Resource {
  static urlRoot() {
    return '/contracts/france/work_types'
  }
}

export default WorkType
